import { FC } from 'react';
import { Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import FlexBox from '../../../../../components/atoms/FlexBox';

interface SignifyModalActionButtonsProps {
  onCancel: () => void;
  onInsert: () => void;
  loadingPrice: boolean;
  productPriceAndAvailabilityData: any;
  hasValidationErrors: boolean;
  shouldShowFooter: boolean;
}

/**
 * Action buttons for the Signify product modal (Cancel/Insert)
 * Handles button states based on loading, validation, and data availability
 */
const SignifyModalActionButtons: FC<SignifyModalActionButtonsProps> = ({
  onCancel,
  onInsert,
  loadingPrice,
  productPriceAndAvailabilityData,
  hasValidationErrors,
  shouldShowFooter,
}) => {
  if (!shouldShowFooter) return null;
  
  const isDisabled = !productPriceAndAvailabilityData || hasValidationErrors;
  const insertButton = (
    <Button
      type="primary"
      onClick={onInsert}
      loading={loadingPrice}
      disabled={isDisabled}
      icon={<PlusOutlined />}
      aria-label={
        !productPriceAndAvailabilityData
          ? 'Insert into table (waiting for product, price, and availability)'
          : hasValidationErrors
          ? 'Insert disabled - fix validation errors'
          : 'Insert product, price, and availability into table'
      }
    >
      Insert
    </Button>
  );

  return (
    <FlexBox style={{ width: '100%' }}>
      <Button onClick={onCancel} aria-label="Cancel and close modal">
        Cancel
      </Button>
      {hasValidationErrors ? (
        <Tooltip title="Please fix field mapping validation errors before inserting">
          {insertButton}
        </Tooltip>
      ) : (
        insertButton
      )}
    </FlexBox>
  );
};

export default SignifyModalActionButtons;

